import jwtAuthAxios from "./auth/jwtAuth";

const skuServices = {};

const appendSkuPayloadToFormData = (formData, payload = {}) => {
    const scalarFields = ["sku", "barcode", "last_scanned_at", "first_manual_pick_at", "hidden"];

    scalarFields.forEach((fieldName) => {
        const value = payload[fieldName];
        if (value !== undefined && value !== null && value !== "") {
            formData.append(`sku[${fieldName}]`, value);
        }
    });

    if (payload.image) {
        formData.append("sku[image]", payload.image);
    }

    const retailCodes = Array.isArray(payload.retail_codes) ? payload.retail_codes : [];
    retailCodes.forEach((retailCode, index) => {
        if (retailCode.id) {
            formData.append(`sku[sku_retail_codes_attributes][${index}][id]`, retailCode.id);
        }

        if (retailCode.retail_name !== undefined) {
            formData.append(`sku[sku_retail_codes_attributes][${index}][retail_name]`, retailCode.retail_name || "");
        }

        if (retailCode.barcode !== undefined) {
            formData.append(`sku[sku_retail_codes_attributes][${index}][barcode]`, retailCode.barcode || "");
        }

        if (retailCode._destroy) {
            formData.append(`sku[sku_retail_codes_attributes][${index}][_destroy]`, "1");
        }
    });
};

skuServices.getSkus = async (params = "") => {
    const { data } = await jwtAuthAxios.get(`/skus${params}`);
    return data;
};

skuServices.createSku = async (payload) => {
    const formData = new FormData();
    appendSkuPayloadToFormData(formData, payload);

    const { data } = await jwtAuthAxios.post(`/skus`, formData, {
        headers: {
            "Content-Type": "multipart/form-data",
        },
    });

    return data;
};

skuServices.updateSku = async (id, payload) => {
    const formData = new FormData();
    appendSkuPayloadToFormData(formData, payload);

    const { data } = await jwtAuthAxios.patch(`/skus/${id}`, formData, {
        headers: {
            "Content-Type": "multipart/form-data",
        },
    });

    return data;
};

skuServices.hideSku = async (id) => {
    const { data } = await jwtAuthAxios.post(`/skus/${id}/hide`);
    return data;
};

skuServices.unhideSku = async (id) => {
    const { data } = await jwtAuthAxios.post(`/skus/${id}/unhide`);
    return data;
};

skuServices.downloadTemplate = async () => {
    const { data } = await jwtAuthAxios.get(`/skus/download_template`, {
        responseType: "arraybuffer",
    });
    return data;
};

skuServices.importSkus = async (files = []) => {
    const formData = new FormData();

    if (Array.isArray(files) && files.length > 0) {
        formData.append("file", files[0]);
    }

    const { data } = await jwtAuthAxios.post(`/skus/import`, formData, {
        headers: {
            "Content-Type": "multipart/form-data",
        },
    });

    return data;
};

skuServices.exportSkus = async (params = "") => {
    const { data } = await jwtAuthAxios.get(`/skus/export${params}`, {
        responseType: "arraybuffer",
    });
    return data;
};

// Existencias en vivo desde el ERP. Va aparte del listado a propósito: cada
// código es una llamada HTTP contra Relbase/Bsale, así que la tabla pinta
// primero desde la base y esto la rellena después.
skuServices.getStock = async (codes = []) => {
    if (!codes.length) return { data: {} };

    const query = codes.map((code) => encodeURIComponent(code)).join(",");
    const { data } = await jwtAuthAxios.get(`/skus/stock?codes=${query}`);
    return data;
};

// Fija, cambia o quita la posición de picking del SKU. Sin code ni bin_id, la
// quita.
skuServices.setBin = async (id, payload = {}) => {
    const { data } = await jwtAuthAxios.put(`/skus/${id}/set_bin`, payload);
    return data;
};

export default skuServices;
